
      import { Buffer } from 'buffer/'; // <-- no typo here ("/")
      import process from 'process';
      import EventEmitter from 'events';

      window.Buffer = Buffer;
      window.process = process;
      window.EventEmitter = EventEmitter;
    